import { IconBase } from '@/components/iconBase/iconBase';
import ColorsType from '@/shared/entities/types/colors.type';
import React, { useMemo } from 'react';
import classesBuilder from 'vkit/lib/shared/utils/classesBuilder';
import style from '@/components/iconBox/iconBox.module.scss';

interface IconBoxProps {
  size?: number;
  icon?: string;
  iconImageUrl?: string;
  bgTransparent?: boolean;
  backgroundColor?: ColorsType;
  color?: ColorsType;
  circle?: boolean;
}

const IconBox: React.FC<IconBoxProps> = ({
  size = 40,
  icon,
  iconImageUrl,
  bgTransparent,
  color = 'colorDefault',
  circle,
}) => {
  const iconSize = useMemo(() => size - 20, [size]);

  return (
    <div
      style={{
        width: size,
        height: size,
        minWidth: size,
      }}
      className={classesBuilder(style, {
        iconBox: true,
        transparent: bgTransparent,
        circle,
        [color]: Boolean(color),
      })}>
      <IconBase size={iconSize} icon={icon} iconImageUrl={iconImageUrl} color={color} />
    </div>
  );
};

export default IconBox;
